import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGpsDisabled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		fill: "currentColor",
		clipPath: "url(#gps-disabled-clip)",
		children: /* @__PURE__ */ _jsx("path", { d: "M1.412.002 0 1.414l2.954 2.954L1 4.948v1.437l6.462 2.153L9.615 15h1.436l.581-1.954L14.586 16 16 14.586l-.003.001zM12.928 8.69 15 1.717 14.282 1 7.311 3.073z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "gps-disabled-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgGpsDisabled;
